import { useSelector } from "react-redux";

export const AllRoles = {
  webUser: "Dispatcher.WebUser",
  loadDownloader: "Dispatcher.LoadDownloader",
  dev: "Dispatcher.Developer",
  mobileUser: "Dispatcher.MobileUser",
};

export const useIsDev = () => {
  const user = useSelector((state) => state.user);
  return user.data?.roles.includes(AllRoles.dev);
};

export const useIsWebUser = () => {
  const user = useSelector((state) => state.user);
  return user.data?.roles.includes(AllRoles.webUser);
};

export const useIsAdminOrDev = () => {
  const user = useSelector((state) => state.user);
  return user.data?.roles.includes(AllRoles.loadDownloader) || user.data?.roles.includes(AllRoles.dev);
};
